/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SessionFrequencyEnum } from './sessionFrequencyEnum';
import { DiagnosisTherapist } from './diagnosisTherapist';
import { PatientAppointment } from './patientAppointment';


/**
 * The patient file\'s treatment plan; the text fields are sanitised HTML.
 */
import {ValidatorFn, Validators} from "@angular/forms";

export interface TreatmentPlan { 
    readonly id: number;
    readonly appointment: PatientAppointment | null;
    readonly therapist: DiagnosisTherapist | null;
    readonly collaboardLinkId: string;
    readonly collaboardUrl: string | null;
    readonly therapyGoals: string;
    readonly plannedProcedures: string;
    readonly prognosis: string;
    readonly notes: string;
    readonly patientAgreements: string;
    readonly plannedSessionCount: number | null;
    readonly sessionFrequency: SessionFrequencyEnum | null;
    readonly sessionFrequencyOther: string;
    readonly createdAt: string | null;
    readonly updatedAt: string | null;
}
export namespace TreatmentPlan {
}

export const TreatmentPlan_id_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const TreatmentPlan_appointment_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const TreatmentPlan_therapist_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const TreatmentPlan_collaboardLinkId_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const TreatmentPlan_collaboardUrl_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const TreatmentPlan_therapyGoals_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const TreatmentPlan_plannedProcedures_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const TreatmentPlan_prognosis_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const TreatmentPlan_notes_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const TreatmentPlan_patientAgreements_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const TreatmentPlan_plannedSessionCount_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const TreatmentPlan_sessionFrequency_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const TreatmentPlan_sessionFrequencyOther_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const TreatmentPlan_createdAt_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const TreatmentPlan_updatedAt_Validators: ValidatorFn[] =
    [  Validators.required, ];


